import { render, staticRenderFns } from "./AllocatePanel.vue?vue&type=template&id=8c134bc6"
import script from "./AllocatePanel.vue?vue&type=script&lang=js"
export * from "./AllocatePanel.vue?vue&type=script&lang=js"
import style0 from "./AllocatePanel.vue?vue&type=style&index=0&id=8c134bc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports